import { render, staticRenderFns } from "./WorldCalendar.vue?vue&type=template&id=773d1461&"
import script from "./WorldCalendar.vue?vue&type=script&lang=js&"
export * from "./WorldCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports